module.exports = __webpack_public_path__ + "static/media/multi-choice.c2a7dc42.svg";